import PricingScreen from './index';

const routes = [
  {
    path: '/onboarding-pricing',
    component: PricingScreen,
  },
];

export default routes;
